import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class RightNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { animeTitle, animeList },
        } = this.props;

        return (
            <div className={styles.right_box}>
                <Chip id="200149" type="struct" title="动漫标题" groupName="动漫" content={animeTitle}>
                    <NewsTitle size="short" />
                </Chip>
                <Chip
                    id="255879"
                    type="recommend"
                    title="动漫列表1"
                    groupName="动漫"
                    content={animeList}
                    translate="handleNewsData">
                    <NewsList hasTitle size="short" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(RightNewsBox);
